// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.32.1
// source: aerial_interfaces/msg/AerialState.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FlightMode } from "./FlightMode";
import { PositionQuality } from "./PositionQuality";

export const protobufPackage = "aerial_interfaces.msg.pb";

/** Flight state */
export interface AerialState {
  flight_mode: FlightMode | undefined;
  flying: boolean;
  /** Altitude and velocity */
  altitude_relative: number;
  vertical_speed: number;
  air_speed: number;
  ground_speed: number;
  heading: number;
  /** Home position and mission time */
  home_latitude: number;
  home_longitude: number;
  home_altitude: number;
  distance_from_home: number;
  flight_time_current: number;
  flight_time_total: number;
  /** Environmental */
  wind_speed: number;
  wind_direction: number;
  /** Core flight quality */
  position_quality: PositionQuality | undefined;
}

function createBaseAerialState(): AerialState {
  return {
    flight_mode: undefined,
    flying: false,
    altitude_relative: 0,
    vertical_speed: 0,
    air_speed: 0,
    ground_speed: 0,
    heading: 0,
    home_latitude: 0,
    home_longitude: 0,
    home_altitude: 0,
    distance_from_home: 0,
    flight_time_current: 0,
    flight_time_total: 0,
    wind_speed: 0,
    wind_direction: 0,
    position_quality: undefined,
  };
}

export const AerialState: MessageFns<AerialState> = {
  encode(message: AerialState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.flight_mode !== undefined) {
      FlightMode.encode(message.flight_mode, writer.uint32(3080779178).fork()).join();
    }
    if (message.flying !== false) {
      writer.uint32(1369715696).bool(message.flying);
    }
    if (message.altitude_relative !== 0) {
      writer.uint32(3565895521).double(message.altitude_relative);
    }
    if (message.vertical_speed !== 0) {
      writer.uint32(3602647881).double(message.vertical_speed);
    }
    if (message.air_speed !== 0) {
      writer.uint32(1827831585).double(message.air_speed);
    }
    if (message.ground_speed !== 0) {
      writer.uint32(2926140613).float(message.ground_speed);
    }
    if (message.heading !== 0) {
      writer.uint32(362945877).float(message.heading);
    }
    if (message.home_latitude !== 0) {
      writer.uint32(552173569).double(message.home_latitude);
    }
    if (message.home_longitude !== 0) {
      writer.uint32(3651775417).double(message.home_longitude);
    }
    if (message.home_altitude !== 0) {
      writer.uint32(4135304433).double(message.home_altitude);
    }
    if (message.distance_from_home !== 0) {
      writer.uint32(2480789297).double(message.distance_from_home);
    }
    if (message.flight_time_current !== 0) {
      writer.uint32(359863785).double(message.flight_time_current);
    }
    if (message.flight_time_total !== 0) {
      writer.uint32(291967145).double(message.flight_time_total);
    }
    if (message.wind_speed !== 0) {
      writer.uint32(1289610073).double(message.wind_speed);
    }
    if (message.wind_direction !== 0) {
      writer.uint32(846205217).double(message.wind_direction);
    }
    if (message.position_quality !== undefined) {
      PositionQuality.encode(message.position_quality, writer.uint32(2048512346).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AerialState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAerialState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 385097397: {
          if (tag !== 3080779178) {
            break;
          }

          message.flight_mode = FlightMode.decode(reader, reader.uint32());
          continue;
        }
        case 171214462: {
          if (tag !== 1369715696) {
            break;
          }

          message.flying = reader.bool();
          continue;
        }
        case 445736940: {
          if (tag !== 3565895521) {
            break;
          }

          message.altitude_relative = reader.double();
          continue;
        }
        case 450330985: {
          if (tag !== 3602647881) {
            break;
          }

          message.vertical_speed = reader.double();
          continue;
        }
        case 228478948: {
          if (tag !== 1827831585) {
            break;
          }

          message.air_speed = reader.double();
          continue;
        }
        case 365767576: {
          if (tag !== 2926140613) {
            break;
          }

          message.ground_speed = reader.float();
          continue;
        }
        case 45368234: {
          if (tag !== 362945877) {
            break;
          }

          message.heading = reader.float();
          continue;
        }
        case 69021696: {
          if (tag !== 552173569) {
            break;
          }

          message.home_latitude = reader.double();
          continue;
        }
        case 456471927: {
          if (tag !== 3651775417) {
            break;
          }

          message.home_longitude = reader.double();
          continue;
        }
        case 516913054: {
          if (tag !== 4135304433) {
            break;
          }

          message.home_altitude = reader.double();
          continue;
        }
        case 310098662: {
          if (tag !== 2480789297) {
            break;
          }

          message.distance_from_home = reader.double();
          continue;
        }
        case 44982973: {
          if (tag !== 359863785) {
            break;
          }

          message.flight_time_current = reader.double();
          continue;
        }
        case 36495893: {
          if (tag !== 291967145) {
            break;
          }

          message.flight_time_total = reader.double();
          continue;
        }
        case 161201259: {
          if (tag !== 1289610073) {
            break;
          }

          message.wind_speed = reader.double();
          continue;
        }
        case 105775652: {
          if (tag !== 846205217) {
            break;
          }

          message.wind_direction = reader.double();
          continue;
        }
        case 256064043: {
          if (tag !== 2048512346) {
            break;
          }

          message.position_quality = PositionQuality.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AerialState {
    return {
      flight_mode: isSet(object.flightMode)
        ? FlightMode.fromJSON(object.flightMode)
        : isSet(object.flight_mode)
        ? FlightMode.fromJSON(object.flight_mode)
        : undefined,
      flying: isSet(object.flying) ? globalThis.Boolean(object.flying) : false,
      altitude_relative: isSet(object.altitudeRelative)
        ? globalThis.Number(object.altitudeRelative)
        : isSet(object.altitude_relative)
        ? globalThis.Number(object.altitude_relative)
        : 0,
      vertical_speed: isSet(object.verticalSpeed)
        ? globalThis.Number(object.verticalSpeed)
        : isSet(object.vertical_speed)
        ? globalThis.Number(object.vertical_speed)
        : 0,
      air_speed: isSet(object.airSpeed)
        ? globalThis.Number(object.airSpeed)
        : isSet(object.air_speed)
        ? globalThis.Number(object.air_speed)
        : 0,
      ground_speed: isSet(object.groundSpeed)
        ? globalThis.Number(object.groundSpeed)
        : isSet(object.ground_speed)
        ? globalThis.Number(object.ground_speed)
        : 0,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      home_latitude: isSet(object.homeLatitude)
        ? globalThis.Number(object.homeLatitude)
        : isSet(object.home_latitude)
        ? globalThis.Number(object.home_latitude)
        : 0,
      home_longitude: isSet(object.homeLongitude)
        ? globalThis.Number(object.homeLongitude)
        : isSet(object.home_longitude)
        ? globalThis.Number(object.home_longitude)
        : 0,
      home_altitude: isSet(object.homeAltitude)
        ? globalThis.Number(object.homeAltitude)
        : isSet(object.home_altitude)
        ? globalThis.Number(object.home_altitude)
        : 0,
      distance_from_home: isSet(object.distanceFromHome)
        ? globalThis.Number(object.distanceFromHome)
        : isSet(object.distance_from_home)
        ? globalThis.Number(object.distance_from_home)
        : 0,
      flight_time_current: isSet(object.flightTimeCurrent)
        ? globalThis.Number(object.flightTimeCurrent)
        : isSet(object.flight_time_current)
        ? globalThis.Number(object.flight_time_current)
        : 0,
      flight_time_total: isSet(object.flightTimeTotal)
        ? globalThis.Number(object.flightTimeTotal)
        : isSet(object.flight_time_total)
        ? globalThis.Number(object.flight_time_total)
        : 0,
      wind_speed: isSet(object.windSpeed)
        ? globalThis.Number(object.windSpeed)
        : isSet(object.wind_speed)
        ? globalThis.Number(object.wind_speed)
        : 0,
      wind_direction: isSet(object.windDirection)
        ? globalThis.Number(object.windDirection)
        : isSet(object.wind_direction)
        ? globalThis.Number(object.wind_direction)
        : 0,
      position_quality: isSet(object.positionQuality)
        ? PositionQuality.fromJSON(object.positionQuality)
        : isSet(object.position_quality)
        ? PositionQuality.fromJSON(object.position_quality)
        : undefined,
    };
  },

  toJSON(message: AerialState): unknown {
    const obj: any = {};
    if (message.flight_mode !== undefined) {
      obj.flightMode = FlightMode.toJSON(message.flight_mode);
    }
    if (message.flying !== false) {
      obj.flying = message.flying;
    }
    if (message.altitude_relative !== 0) {
      obj.altitudeRelative = message.altitude_relative;
    }
    if (message.vertical_speed !== 0) {
      obj.verticalSpeed = message.vertical_speed;
    }
    if (message.air_speed !== 0) {
      obj.airSpeed = message.air_speed;
    }
    if (message.ground_speed !== 0) {
      obj.groundSpeed = message.ground_speed;
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.home_latitude !== 0) {
      obj.homeLatitude = message.home_latitude;
    }
    if (message.home_longitude !== 0) {
      obj.homeLongitude = message.home_longitude;
    }
    if (message.home_altitude !== 0) {
      obj.homeAltitude = message.home_altitude;
    }
    if (message.distance_from_home !== 0) {
      obj.distanceFromHome = message.distance_from_home;
    }
    if (message.flight_time_current !== 0) {
      obj.flightTimeCurrent = message.flight_time_current;
    }
    if (message.flight_time_total !== 0) {
      obj.flightTimeTotal = message.flight_time_total;
    }
    if (message.wind_speed !== 0) {
      obj.windSpeed = message.wind_speed;
    }
    if (message.wind_direction !== 0) {
      obj.windDirection = message.wind_direction;
    }
    if (message.position_quality !== undefined) {
      obj.positionQuality = PositionQuality.toJSON(message.position_quality);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AerialState>, I>>(base?: I): AerialState {
    return AerialState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AerialState>, I>>(object: I): AerialState {
    const message = createBaseAerialState();
    message.flight_mode = (object.flight_mode !== undefined && object.flight_mode !== null)
      ? FlightMode.fromPartial(object.flight_mode)
      : undefined;
    message.flying = object.flying ?? false;
    message.altitude_relative = object.altitude_relative ?? 0;
    message.vertical_speed = object.vertical_speed ?? 0;
    message.air_speed = object.air_speed ?? 0;
    message.ground_speed = object.ground_speed ?? 0;
    message.heading = object.heading ?? 0;
    message.home_latitude = object.home_latitude ?? 0;
    message.home_longitude = object.home_longitude ?? 0;
    message.home_altitude = object.home_altitude ?? 0;
    message.distance_from_home = object.distance_from_home ?? 0;
    message.flight_time_current = object.flight_time_current ?? 0;
    message.flight_time_total = object.flight_time_total ?? 0;
    message.wind_speed = object.wind_speed ?? 0;
    message.wind_direction = object.wind_direction ?? 0;
    message.position_quality = (object.position_quality !== undefined && object.position_quality !== null)
      ? PositionQuality.fromPartial(object.position_quality)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
